export default __webpack_public_path__ + "static/media/big_01.b48ca0a1.png";